module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('header', {
    staticClass: "gheader"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.onClickCancel
    }
  }, [_vm._v("キャンセル")])]), _c('button', {
    staticClass: "gheader__start-btn btn01 -w110",
    attrs: {
      "disabled": _vm.clicked
    },
    on: {
      "click": _vm.onClickSave
    }
  }, [_c('span', [_vm._v("保存する")])])]), (_vm.callbackflg) ? _c('div', {
    staticClass: "container profile-container bg04"
  }, [_c('div', {
    staticClass: "profile-box mb30"
  }, [(_vm.profileImagePath) ? _c('div', {
    staticClass: "profile-box__img"
  }, [_c('div', {
    staticClass: "profile-box__img__inner",
    on: {
      "click": _vm.onFileDummyClick
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.profileImagePath + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  }), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "file",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _c('div', {
    staticClass: "profile-box__img__layer"
  })]), _c('a', {
    staticClass: "profile-box__img__delete",
    on: {
      "click": _vm.onFileDelete
    }
  }, [_vm._v("削除")])]) : _c('div', {
    staticClass: "profile-box__img"
  }, [_c('div', {
    staticClass: "profile-box__img__inner",
    on: {
      "click": _vm.onFileDummyClick
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png")
    }
  }), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "file",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _c('div', {
    staticClass: "profile-box__img__layer"
  })])]), _c('div', {
    staticClass: "profile-box__body"
  }, [_c('p', {
    staticClass: "profile-box__body__role"
  }, [_vm._v(_vm._s(_vm.profile.attributes['shop-name']) + " " + _vm._s(_vm.profile.attributes['user-type-name']))]), _c('div', {
    staticClass: "profile-box__body__name"
  }, [_c('dl', [_c('dt', [_vm._v(_vm._s(_vm.profile.attributes['user-name']))]), _c('dd', [_vm._v(_vm._s(_vm.profile.attributes['user-name-furigana']))])]), _c('dl', [_c('dt', [_vm._v(_vm._s(_vm.profile.attributes['user-firstname']))]), _c('dd', [_vm._v(_vm._s(_vm.profile.attributes['user-firstname-furigana']))])])]), _c('div', {
    staticClass: "profile-box__body__info"
  }, [_c('p', {
    staticClass: "profile-box__body__info__entry"
  }, [_c('span', [_vm._v(_vm._s(_vm.profile.attributes['user-joinday-format']))]), _vm._v("入社")]), _c('p', {
    staticClass: "profile-box__body__info__birth"
  }, [_c('span', [_vm._v(_vm._s(_vm.profile.attributes['user-birthday-format'].slice(5)))]), _vm._v("誕生日")])])])]), (_vm.uploadError && _vm.upFlg) ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("画像はjpgかpng形式でお願いします")])]) : _vm._e(), _c('table', {
    staticClass: "profile-contents"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "profile-contents__head"
  }, [_vm._v("一言")]), _c('td', {
    staticClass: "profile-contents__body"
  }, [_c('p', {
    staticClass: "profile-contents__body__sub-txt fz13"
  }, [_vm._v("（最大100文字）")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.singleWord),
      expression: "singleWord"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "100",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.singleWord)
    },
    on: {
      "change": function($event) {
        _vm.rmEmoji(_vm.singleWord, 'singleWord')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.singleWord = $event.target.value
      }
    }
  })])]), _c('tr', [_c('th', {
    staticClass: "profile-contents__head"
  }, [_vm._v("特技")]), _c('td', {
    staticClass: "profile-contents__body"
  }, [_c('p', {
    staticClass: "profile-contents__body__sub-txt fz13"
  }, [_vm._v("（最大100文字）")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.specialSkill),
      expression: "specialSkill"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "100",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.specialSkill)
    },
    on: {
      "change": function($event) {
        _vm.rmEmoji(_vm.specialSkill, 'specialSkill')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.specialSkill = $event.target.value
      }
    }
  })])]), _c('tr', [_c('th', {
    staticClass: "profile-contents__head"
  }, [_vm._v("趣味")]), _c('td', {
    staticClass: "profile-contents__body"
  }, [_c('p', {
    staticClass: "profile-contents__body__sub-txt fz13"
  }, [_vm._v("（最大100文字）")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hobby),
      expression: "hobby"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "100",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.hobby)
    },
    on: {
      "change": function($event) {
        _vm.rmEmoji(_vm.hobby, 'hobby')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hobby = $event.target.value
      }
    }
  })])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b78ee874!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/profile-edit.pug
// module id = 1455
// module chunks = 1